
<div class="Section ProblemAwareness" id="challenges">
    <div class="SectionContainer">
        <div class="SectionHeader">
            <div class="HeaderBadge">Probleme erkennen</div>
            <h2 class="SectionTitle">
                <span class="TitleAccent">Kritische Herausforderungen</span>
                für Taxi- und Mietwagenunternehmer
            </h2>
            <div class="AlertBar">
                <i class="ri-alert-line"></i>
                <p>
                    Diese Probleme kosten Taxi- und Mietwagenunternehmer jährlich tausende Euro
                    und wertvolle Zeit
                </p>
            </div>
        </div>

        <div class="ChallengesGrid">
            <div class="ChallengeCard">
                <div class="ProblemTag">Problem #1</div>
                <div class="CardIcon">
                    <i class="ri-shield-line" style="font-size: 24px"></i>
                </div>
                <div class="CardContent">
                    <h3>Gesetzliche Vorgaben</h3>
                    <div class="ProblemImpact">
                        <i class="ri-file-damage-line"></i>
                        <span>Bußgelder bis zu 25.000€</span>
                    </div>
                    <p>
                        Ständig wechselnde Anforderungen (INSIKA/TSE) führen zu hohen Bußgeldern
                        bei Nichteinhaltung.
                    </p>
                </div>
            </div>
            <div class="ChallengeCard">
                <div class="ProblemTag">Problem #2</div>
                <div class="CardIcon">
                    <i class="ri-admin-line" style="font-size: 24px"></i>
                </div>
                <div class="CardContent">
                    <h3>Aufwändige Verwaltung</h3>
                    <div class="ProblemImpact">
                        <i class="ri-timer-line"></i>
                        <span>15+ Stunden/Woche verschwendet</span>
                    </div>
                    <p>
                        Zeitverschwendung durch komplizierte Software, die mehr Probleme
                        verursacht als löst.
                    </p>
                </div>
            </div>

            <div class="ChallengeCard">
                <div class="ProblemTag">Problem #3</div>
                <div class="CardIcon">
                    <i class="ri-time-line" style="font-size: 24px"></i>
                </div>
                <div class="CardContent">
                    <h3>Hohe versteckte Kosten</h3>
                    <div class="ProblemImpact">
                        <i class="ri-money-euro-circle-line"></i>
                        <span>Bis zu 2.500€ Mehrkosten/Jahr</span>
                    </div>
                    <p>
                        Verpasste Fristen für P-Scheine und wichtige Dokumente führen zu hohen
                        finanziellen Einbußen.
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>
